import {ActionCreatorWithoutPayload} from "@reduxjs/toolkit";
import {Role} from "../../session_state";


export type Page = {
    id: string;
    name: string;
    action?: ActionCreatorWithoutPayload;
    route?: string;
    roles: Array<Role>
    pages?: Page[]
}

export const userMenu: Page[] = [
    {
        id: 'profile',
        name: 'Profil',
        route: "/profile",
        roles: [Role.Admin, Role.Foreman, Role.Worker, Role.Analytics]
    },
];


export const mainMenu: Page = {

    id: "main",
    name: "Glavni meni",
    roles: [],
    pages:
        [
            {id: "reg", name: 'Registracija dela', route: "/reg", roles: [Role.Worker, Role.Admin, Role.Foreman]},
            {
                id: "openreg",
                name: 'Odprte prijave',
                roles: [ Role.Admin, Role.Foreman, Role.AllRegs],
                pages: [
                    {id: "all", name: 'Vse', route: "/regs/all", roles: [Role.Admin, Role.Foreman, Role.AllRegs]},
                    {id: "operation", name: 'Za operacijo', route: "/regs/oper", roles: [Role.Admin, Role.AllRegs, Role.Foreman]},
                    {id: "unregistered", name: 'Neregistrirani delavci', route: "/regs/unregistered", roles: [Role.AllRegs]},
                ]
            },
            {id: "workorder", name: 'Delovni nalogi', route: "/workorder", roles: [Role.Worker, Role.Admin, Role.Foreman]},
            {id: "sync", name: 'Sinhronizacija z e-računi', route: "/sync", roles: [ Role.Admin, Role.Foreman]},

            {
                id: "analytics",
                name: 'Analitika', roles: [Role.Admin, Role.Analytics], pages: [
                    {id: "regs", name: 'Zgodovina prijav', roles: [Role.Admin, Role.Analytics], route: "/analytics/reg"},
                    {id: "regs_by_oper", name: "Ure po operaciji", roles: [Role.Admin, Role.Analytics], route: "/analytics/operation"},
                    {id: "regs_by_worker", name: 'Ure za delavce', roles: [Role.Admin, Role.Analytics], route: "/analytics/worker"},
                    {id: "regs_by_dn", name: 'Ure za delovni nalog', roles: [Role.Admin, Role.Analytics], route: "/analytics/dn"},
                    {id: "regs_by_machine", name: 'Ure za stroj', roles: [Role.Admin, Role.Analytics], route: "/analytics/machine"},
                    {id: "regs_by_customer", name: 'Ure za kupce', roles: [Role.Admin,Role.Analytics], route: "/analytics/customer"},
                    {id: "create", name: 'Dodaj registracijo', roles: [Role.Admin,Role.Analytics], route: "/analytics/create"},
                ]
            },
            {
                name: "Šifranti",
                id: "masterdata",
                roles: [Role.Worker, Role.Admin, Role.Foreman,],
                pages: [
                    {
                        id: "products",
                        name: 'Pregled artiklov',
                        roles: [Role.Worker, Role.Admin, Role.Foreman,],
                        route: "/products"
                    },
                    {id: "partners", name: 'Stranke', roles: [Role.Admin], route: "/partners"},
                    {id: "person", name: 'Upravljanje delavcev', roles: [Role.Admin, Role.Foreman], route: "/person"},
                    {id: "operation", name: 'Upravljanje operacij', roles: [Role.Admin], route: "/operation"},
                    {id: "intr", name: 'Vrste prekinitev', roles: [Role.Admin], route: "/intr"},
                    {id: "machine", name: 'Upravljanje delovnih mest', roles: [Role.Admin], route: "/machine"},
                    {id: "users", name: 'Uporabniki', roles: [Role.Admin], route: "/users"},
                ]
            },

        ]
}
